<template>
  <layout-switch :loading="appState.loading === 'Loading' || permissionsStore.loading">
    <template #content>
      <rr-main-menu :items="mainMenuForRouter" :is-minimized="!appState.isSidebarOpened" />
    </template>
    <router-view v-if="appState.appReady && canShowRouterView" />
  </layout-switch>
  <div
    v-if="isAuthenticated && !permissionsStore.loaded"
    class="pokolenie-permissions-loader"
    aria-busy="true"
    aria-live="polite"
  >
    <rr-loader />
  </div>
  <rr-modal-manager />
  <task-status-popups-host />
</template>

<script setup lang="ts">
import { computed, onBeforeMount, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useSeedkitApi } from '@seedkit/core';
import { useAppStore } from '@seedkit/vue/stores';
import {
  RrModalManager,
  useTheme,
} from '@seedkit/vue/plugins';
import { useSession } from '@seedkit/vue-administration-module/public';
import { LayoutSwitch } from 'app/theme/components/layout-switch';
import { MAIN_MENU_ITEMS } from 'app/src/app/mocks/mainMenu.ts';
import TaskStatusPopupsHost from 'app/src/shared/ui/task-status-popups/TaskStatusPopupsHost.vue';
import {
  setNotificationsHubApiBaseUrl,
  tryConnectNotificationsHub,
} from 'app/src/modules/notifications-hub/notifications-hub-bootstrap';
import { initSeedkitThemeStateDarkClassSync } from 'app/src/app/sync-seedkit-theme-state-dark-class.ts';
import { useMainMenuWithUnreadBadges } from 'app/src/app/composables/use-main-menu-with-unread-badges';
import { refreshSidebarUnreadBadges } from 'app/src/shared/sidebar-unread-badges/sidebar-unread-badges-bootstrap';
import { usePermissionsStore } from 'app/src/shared/permissions/permissions.store';

const { onBeforeAppMount } = useTheme();

onBeforeMount(() => {
  onBeforeAppMount();
  initSeedkitThemeStateDarkClassSync();
});

const appState = useAppStore();
const session = useSession();
const permissionsStore = usePermissionsStore();
appState.mainMenu.push(...MAIN_MENU_ITEMS);

const isAuthenticated = computed(
  () => !session.isAccessTokenEmpty && !session.isTokenExpired,
);
const canShowRouterView = computed(
  () => !isAuthenticated.value || permissionsStore.loaded,
);

const router = useRouter();
const mainMenuForRouter = useMainMenuWithUnreadBadges();

onMounted(() => {
  const adminApi = useSeedkitApi('Admin');
  const baseFromClient = String((adminApi as { http?: { baseUrl?: string } }).http?.baseUrl || '');
  if (baseFromClient) {
    console.log('baseFromClient if', baseFromClient);
    setNotificationsHubApiBaseUrl(baseFromClient);
  } else {
    console.log('baseFromClient else', baseFromClient);
    setNotificationsHubApiBaseUrl('https://fondpokolenie.dev.rusrobots.ru');
  }
  void tryConnectNotificationsHub();

  if (isAuthenticated.value) {
    refreshSidebarUnreadBadges();
  }
});

watch(
  () => router.currentRoute.value.name,
  () => {
    if (isAuthenticated.value) {
      refreshSidebarUnreadBadges();
    }
  },
);
</script>
<style>
@import url('../assets/css/index.css');
@import url('@seedkit/vue/css/rr-overlay.css');

.pokolenie-permissions-loader {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(255 255 255 / 72%);
}
</style>
